import {APIError} from 'data/errors';
import {HttpStatusCode} from 'data/protocols/http';
import {LogEventBookingEnum} from 'main/analytics/logEventEnum';
import {OperationStateTypesEnum} from 'presentation/constants';
import {APIErrorMessage, ResolveBookingErrorResult} from './types';

function resolveBookingError(error: unknown): ResolveBookingErrorResult {
	if (error instanceof APIError) {
		if (error.statusCode === HttpStatusCode.unprocessable) {
			return {state: OperationStateTypesEnum.ERROR, errorCode: error.errorCode};
		}

		const notificationMessage = (error.message as APIErrorMessage)?.notifications?.[0]?.message;
		const isBadRequest = error.statusCode === HttpStatusCode.badRequest;

		if (
			isBadRequest &&
			notificationMessage === LogEventBookingEnum.PORTAL_TELE_BOOKING_UNAUTHORIZED
		) {
			return {state: OperationStateTypesEnum.UNAUTHORIZED};
		}

		if (
			isBadRequest &&
			(notificationMessage?.endsWith(LogEventBookingEnum.PORTAL_TELE_BOOKING_UNAVAILABLE) ||
				['(002)', '(003)'].some(code => notificationMessage?.includes(code)))
		) {
			return {state: OperationStateTypesEnum.UNAVAILABLE};
		}
	}

	return {state: OperationStateTypesEnum.ERROR};
}

export {resolveBookingError};
